export const environment = {
  production: false,
  enable_test_ui: false,
  base_url: 'https://api.payarc.net/v1',
  googleAnalyticsId: 'G-7XE0XMNLME'
};
